module.exports = __webpack_public_path__ + "img/public/SiteIcons/letGoIcon.svg?04f64807";